<template>
    <div>{{action.summary}}</div>
</template>

<script>
    import BaseActionSummary from '../base-action-summary';

    export default {
        name: 'schedule-payment-summary',
        extends: BaseActionSummary,
    };
</script>
